import { ENUM_MortgagePartStepType } from '@api-new/common';
import { HTTP_CP_CreateSmartSearch_Request } from '@api-new/mortgageservice';
import { SmartSearchType } from '@platform/smart-search/enums/smart-search-type.enum';
import { AddSmartSearchDialogFormRawValues } from '@platform/smart-search/utils/formUtils';

export const createSmartSearchFormToHTTPRequestAdapter = (data: AddSmartSearchDialogFormRawValues): HTTP_CP_CreateSmartSearch_Request => {
  const specifySearch = {
    name: data.specifySearch.smartSearchName,
    includeInitialRateTypeFixed: data.specifySearch.initialInterestRateType.includes(
      ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_FIXED,
    ),
    includeInitialRateTypeVariable: data.specifySearch.initialInterestRateType.includes(
      ENUM_MortgagePartStepType.MORTGAGE_PART_STEP_TYPE_VARIABLE,
    ),
    minimumInitialRatePeriodInMonths: data.specifySearch.comparisonPeriod[0] * 12,
    maximumInitialRatePeriodInMonths: data.specifySearch.comparisonPeriod[1] * 12,
  };

  const forBuyPropertyMaximumValue = {
    propertyValue: data.newPropertyMaximumPrice.propertyPrice,
    deposit: data.newPropertyMaximumPrice.deposit,
    newTermInMonths: data.newPropertyMaximumPrice.newTermInMonths,
    propertyInvestmentType: data.newPropertyInvestmentTypeSelection.type,
    propertyPurchaseType: data.newPropertyPurchaseTypeSelection.type,
  };

  const forRemortgageBorrowMore = {
    propertyId: data.propertySelection.propertyMortgageSelectItem?.propertyId,
    loanAmountIncrease: data.remortgageBorrowMore.loanAmountIncrease,
    newTermInMonths: data.remortgageBorrowMore.termInMonths,
    smartSearchRemortgageReason: data.remortgageBorrowMore.reason,
  };

  const forRemortgagePayFaster = {
    propertyId: data.propertySelection.propertyMortgageSelectItem?.propertyId,
    monthlyPaymentIncrease: data.remortgagePayMortgageFaster.monthlyPaymentIncrease,
  };

  return {
    ...specifySearch,
    ...(data.typeSelection.type === SmartSearchType.NEW_PROPERTY_MAXIMUM_PRICE && { forBuyPropertyMaximumValue }),
    ...(data.typeSelection.type === SmartSearchType.MORTGAGE_BORROW_MORE && { forRemortgageBorrowMore }),
    ...(data.typeSelection.type === SmartSearchType.MORTGAGE_PAY_FASTER && { forRemortgagePayFaster }),
  };
};
